import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./locais.component.html')
})
export class LocaisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/locais.component.ts
 **/